import React from 'react'

import AccordionMolecule from '@/molecules/Accordion'

const Accordion = (props) => (
  <AccordionMolecule {...props}/>
)

export default Accordion
